import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { ConnectivityService } from 'src/app/core/services/connectivity.service';
import { SessionTimerService } from 'src/app/core/services/session-timer.service';
import { LoginService } from 'src/app/login/login.service';
import { catchError, switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    selector: 'maintenance-dialog',
    templateUrl: './maintenance-dialog.component.html'
})
export class MaintenanceDialogComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  private sessionTimerService = inject(SessionTimerService);
  private connectivityService = inject(ConnectivityService);
  private loginService = inject(LoginService);

  savingText = 'Saving...';
  savingDots = '.';
  savingInterval: any;
  statusText = 'Storing your task data';

  ngOnInit(): void {
    this.savingInterval = setInterval(() => {
      this.savingText = 'Saving' + this.savingDots;
      this.savingDots += '.';
      if (this.savingDots.length > 3) {
        this.savingDots = '.';
      }
      this.cdr.detectChanges();
    }, 500);

    setTimeout(() => {
      clearInterval(this.savingInterval);
      this.savingText = 'Success!';
      document.querySelector('.maintenance-dialog-container')?.classList.add('success');
      this.cdr.detectChanges();
      this.statusText = 'All set! Session data saved.';
      this.cdr.detectChanges();
      setTimeout(() => {
        this.triggerLogout();
      }, 3000);
    }, 3000);
  }

  logoutUser() {
    this.loginService.studentLogout().pipe(take(1)).subscribe();
  }

  private triggerLogout() {
    this.sessionTimerService.triggerLogout$.pipe(
      switchMap(() => {
        return this.connectivityService.checkServerConnectivity().pipe(
          catchError(error => {
            this.loginService.demoLogout();
            return of({});
          }),
        );
      }),
      switchMap(() => {
        return this.loginService.studentLogout().pipe(
          catchError(error => {
            this.loginService.demoLogout();
            return of({});
          }),
        );
      }),
    ).subscribe();

    this.logoutUser();
  }
}